import { create } from 'zustand';

// Dexie-backed app data, synced into Zustand by useDexieSync. Components read from
// here via selectors instead of running their own useLiveQuery, so a Dexie write
// re-runs each table query exactly once per change instead of once-per-consumer.
const useDataStore = create((set) => ({
  recipes: [],
  categories: [],
  groceryLists: [],
  groceryItems: [],
  mealPlans: [],
  initialized: false,
  syncing: false,

  setRecipes: (recipes) => set({ recipes }),
  setCategories: (categories) => set({ categories }),
  setGroceryLists: (groceryLists) => set({ groceryLists }),
  setGroceryItems: (groceryItems) => set({ groceryItems }),
  setMealPlans: (mealPlans) => set({ mealPlans }),
  setInitialized: (initialized) => set({ initialized }),
  setSyncing: (syncing) => set({ syncing }),
}));

export default useDataStore;
